<template>
  <div>
    <div class="container">
      <div class="row mt-4 d-flex justify-content-start align-items-center">
        <div class="w-100 d-flex justify-content-between">
          <i class="fa fa-check-circle fa-3x text-primary mb-2"></i>
          <h3 class="mt-2">Calificaciones</h3>
          <button style="opacity: 0;" class="btn rounded-circle mt-1">
            <i class="fa fa-expand" v-if="!isExpanded"></i>
            <i class="fa fa-compress" v-else></i>
          </button>
        </div>
        <!-- <p>Informacion calificaciones: {{ infocal }}</p> -->

        <div v-if="infocal && infocal.length">
          <table class="table">
            <thead>
              <tr>
                <th>Etiqueta</th>
                <th>Descripción</th>
                <th>Evaluaciones</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(item, index) in infocal" :key="index">
                <td>{{ item.etiquetas }}</td>
                <td>{{ item.description }}</td>
                <td>
                  <span v-if="item.evaluaciones.length">
                    {{ item.evaluaciones.join(', ') }}
                  </span>
                  <span v-else>
                    Sin evaluaciones
                  </span>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div v-else>
          <p class="w-100 text-center">No hay encuestas calificadas</p>
        </div>

        <!-- <div v-if="isExpanded" class="w-100 row">
          <div class="col-md-7 col-sm-12">
            Soy la parte de la izquierda
          </div>
          <div style="height: 55vh;" class="vr p-0 divider"></div>
          <div class="col-md-4 col-sm-12">
            Soy la parte de la derecha
          </div>
        </div> -->
      </div>
    </div>
    <div></div>
  </div>
</template>

<script>
import Calificaciones from "@/api-services/dashboards.yacalificame.service";
import ServiciosDashboard from "@/api-services/dashboardsgeneral.yacalificame.service";

export default {
  name: "Calificaciones",
  data() {
    return {
      isExpanded: false,
      infocal: null,
      info: [
        {
          etiquetas: "Servicio",
          description: "¿Cómo calificarías la calidad de nuestro servicio?",
          evaluaciones: [5.3]
        },
        {
          etiquetas: "Limpieza",
          description: "¿Cómo calificarías la limpieza y presentación de nuestras instalaciones?",
          evaluaciones: [4.5]
        },
        {
          etiquetas: "Eficiencia",
          description: "¿La eficiencia de los colaboradores en sus tareas fue satisfactoria?",
          evaluaciones: []  // Sin evaluaciones
        },
        {
          etiquetas: "Comunicación",
          description: "¿La comunicación de los colaboradores fue efectiva?",
          evaluaciones: [3.4]
        },
        {
          etiquetas: "Satisfacción",
          description: "¿Qué tan satisfecho/a estás con el trabajo de los colaboradores?",
          evaluaciones: [5]
        }
      ],
      cargando: true,
      MsgError: "",
      BaseGetsListado: {
        Borrados: false,
        PaginaNo: 0,
        PaginaLen: 10,
        Filtro: "",
      },
    };
  },
  created() {
    this.fetchCalificaciones();
  },
  beforeMount() {
    ServiciosDashboard.getsCalificaciones(null, {}, (response) => {
      console.debug("Dahsboard", response);
      this.infocal = response.data;
    });
  },
  methods: {
    fetchCalificaciones() {
      Calificaciones.gets(this, {}, (response) => {
        console.debug("Estas son las encuestas calificadas: ", response);
        this.info = response.data || this.info;
      });
    },
    agregarEstrella(index) {
      if (this.info[index] && this.info[index].evaluaciones) {
        this.info[index].evaluaciones.push(1);
      } else {
        this.$set(this.info[index], 'evaluaciones', [1]);
      }
    },
    toggleExpand() {
      this.isExpanded = !this.isExpanded;
      this.$emit('expand', this.isExpanded); // Emitir evento expand
    },
    Expandir() {
      this.isExpanded = !this.isExpanded;
      if (this.isExpanded == false) {
        this.$emit("Expandir", "Todas");
        return;
      }
      this.$emit("Expandir", "Calificaciones");
    }
  }
};
</script>

<style scoped lang="scss">
.divider {
  display: block;
}

@media (max-width: 575.98px) {
  .divider {
    display: none;
  }
}
</style>
